import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price) {
  if (price) return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return "";
}

export function getShareLink(model, shortId) {
  return `${import.meta.env.VITE_UI_URL}/share/${model}/${shortId}`;
}
